
import "./events.scss";
import React, { useState } from "react";
import Event from "../event/Event";
import { useQuery } from "react-query";

import api  from "../../services/api";

const retrieveEvents = async (props, page) => {
  // we need to checks the props if we are filtering by target or case
  let res;
  const params = { page };
  /* count: 15
next:"http://localhost/api/osint/event/?page=2"
previous:null
results:[{id: 32161, title: "Event", tim...
  */
  if (props.targetId) {
    params.targets = [props.targetId];
    res = await api.get(`/api/osint/targets_event/`, { params });
  } else if (props.caseId) {
    params.cases = [props.caseId];
    res = await api.get(`/api/osint/cases_event/`, { params });
  } else if (props.filter === 'GEO') {
    params.query_type = 'GEOLOCATION';
    res = await api.get("/api/osint/event/", { params });
  } else {
    res = await api.get("/api/osint/event/", { params });
  }

  return res.data;
};

const Events = (props) => {
  const [currentPage, setCurrentPage] = useState(1);

  const {
    data: events,
    error,
    isLoading,
    isFetching,
  } = useQuery(
    ["case_events", props, currentPage],
    () => retrieveEvents(props, currentPage),
    { keepPreviousData: true }
  );

  if (isLoading) return <div>Fetching events...</div>;
  if (error) return <div>An error occurred: {error.message}</div>;

  return (
    <div className="events">
      {events.results.map((event) => (
        <Event event={event} key={event.id} />
      ))}

      {/* Pagination Controls */}
      <div className="pagination">
      <button
          onClick={() => setCurrentPage(1)}
          disabled={!events.previous}
        >
          &lt;&lt;
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={!events.previous}
        >
          &lt;
        </button>
        <button
          // Scroll to top of the page
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >Top
        </button>
        <span>Records: ({events.count})&nbsp;-&nbsp;</span>
        <span>Page {currentPage} of {Math.ceil(events.count / 10)}</span>

        <button
          onClick={() => {
            if (events.next) {
              setCurrentPage((prev) => prev + 1);
            }
          }}
          disabled={!events.next}
        >
          &gt;
        </button>
        <button
          onClick={() => {
            if (events.next) {
              setCurrentPage(Math.ceil(events.count / 10));
            }
          }}
          disabled={!events.next}
        >
          &gt;&gt;
        </button>
      </div>

      {isFetching && <div>Loading...</div>}
    </div>
  );
};

export default Events;